import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, UsersIcon, ClipboardListIcon, FolderIcon, CalendarIcon, MessageSquareIcon, BarChartIcon, SettingsIcon, ChevronDownIcon, ChevronRightIcon, FileTextIcon, ChevronLeftIcon } from 'lucide-react';
interface LeftNavProps {
  isOpen: boolean;
}
export function LeftNav({
  isOpen
}: LeftNavProps) {
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [applicationsOpen, setApplicationsOpen] = useState(location.pathname.startsWith('/applications'));
  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };
  return <aside className={`bg-white border-r border-neutral-200 transition-all duration-300 ease-in-out ${isOpen ? 'w-60' : 'w-16'} fixed inset-y-0 left-0 z-30 md:relative md:translate-x-0 flex flex-col`} data-id="element-601">
      <div className="p-3 border-b border-neutral-200 flex items-center justify-center h-16" data-id="element-602">
        {isOpen ? <h2 className="text-xl font-bold text-primary-600" data-id="element-603">TPTM</h2> : <h2 className="text-xl font-bold text-primary-600" data-id="element-604">T</h2>}
      </div>
      <nav className="mt-4 px-3 flex-1" data-id="element-605">
        <ul className="space-y-1" data-id="element-606">
          <li data-id="element-607">
            <Link to="/" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/') && !isActive('/leads') && !isActive('/clients') && !isActive('/deals') && !isActive('/applications') && !isActive('/renewals') && !isActive('/communication') && !isActive('/reports') && !isActive('/settings') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-608">
              <LayoutDashboardIcon className="h-5 w-5 mr-3" data-id="element-609" />
              {isOpen && <span data-id="element-610">Dashboard</span>}
            </Link>
          </li>
          <li data-id="element-611">
            <Link to="/leads" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/leads') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-612">
              <UsersIcon className="h-5 w-5 mr-3" data-id="element-613" />
              {isOpen && <span data-id="element-614">Leads</span>}
            </Link>
          </li>
          <li data-id="element-615">
            <Link to="/clients" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/clients') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-616">
              <UsersIcon className="h-5 w-5 mr-3" data-id="element-617" />
              {isOpen && <span data-id="element-618">Clients</span>}
            </Link>
          </li>
          {/* Applications Section with submenu */}
          <li data-id="element-619">
            <button className={`flex w-full items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/applications') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} onClick={() => setApplicationsOpen(!applicationsOpen)} data-id="element-620">
              <FileTextIcon className="h-5 w-5 mr-3" data-id="element-621" />
              {isOpen && <>
                  <span data-id="element-622">Applications</span>
                  <span className="ml-auto" data-id="element-623">
                    {applicationsOpen ? <ChevronDownIcon size={16} data-id="element-624" /> : <ChevronRightIcon size={16} data-id="element-625" />}
                  </span>
                </>}
            </button>
            {isOpen && applicationsOpen && <ul className="mt-1 space-y-1 pl-8" data-id="element-626">
                <li data-id="element-627">
                  <Link to="/applications" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/applications' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-628">
                    All Applications
                  </Link>
                </li>
                <li data-id="element-629">
                  <Link to="/applications/documents" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/applications/documents' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-630">
                    Documents
                  </Link>
                </li>
              </ul>}
          </li>
          <li data-id="element-631">
            <Link to="/deals/kanban" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/deals') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-632">
              <ClipboardListIcon className="h-5 w-5 mr-3" data-id="element-633" />
              {isOpen && <span data-id="element-634">Deals</span>}
            </Link>
          </li>
          <li data-id="element-635">
            <Link to="/renewals" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/renewals') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-636">
              <CalendarIcon className="h-5 w-5 mr-3" data-id="element-637" />
              {isOpen && <span data-id="element-638">Renewals</span>}
            </Link>
          </li>
          <li data-id="element-639"></li>
          <li data-id="element-640">
            <Link to="/reports" className={`flex items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/reports') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} data-id="element-641">
              <BarChartIcon className="h-5 w-5 mr-3" data-id="element-642" />
              {isOpen && <span data-id="element-643">Reports</span>}
            </Link>
          </li>
          {/* Settings Section */}
          <li data-id="element-644">
            <button className={`flex w-full items-center rounded-md px-3 py-2 text-sm font-medium ${isActive('/settings') ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} onClick={() => setSettingsOpen(!settingsOpen)} data-id="element-645">
              <SettingsIcon className="h-5 w-5 mr-3" data-id="element-646" />
              {isOpen && <>
                  <span data-id="element-647">Settings</span>
                  <span className="ml-auto" data-id="element-648">
                    {settingsOpen ? <ChevronDownIcon size={16} data-id="element-649" /> : <ChevronRightIcon size={16} data-id="element-650" />}
                  </span>
                </>}
            </button>
            {isOpen && settingsOpen && <ul className="mt-1 space-y-1 pl-8" data-id="element-651">
                <li data-id="element-652">
                  <Link to="/settings/organization" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/organization' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-653">
                    Organization
                  </Link>
                </li>
                <li data-id="element-654">
                  <Link to="/settings/users-roles" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/users-roles' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-655">
                    Users & Roles
                  </Link>
                </li>
                <li data-id="element-656">
                  <Link to="/settings/integrations" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/integrations' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-657">
                    Integrations
                  </Link>
                </li>
                <li data-id="element-658">
                  <Link to="/settings/templates" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/templates' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-659">
                    Templates
                  </Link>
                </li>
                <li data-id="element-660">
                  <Link to="/settings/naming-rules" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/naming-rules' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-661">
                    Naming Rules
                  </Link>
                </li>
                <li data-id="element-662">
                  <Link to="/settings/audit-log" className={`block rounded-md px-3 py-1.5 text-sm font-medium ${location.pathname === '/settings/audit-log' ? 'bg-primary-50 text-primary-600' : 'text-neutral-600 hover:bg-neutral-50'}`} data-id="element-663">
                    Audit Log
                  </Link>
                </li>
              </ul>}
          </li>
        </ul>
      </nav>
      {/* Toggle sidebar button at the bottom */}
      <div className="p-3 border-t border-neutral-200 flex justify-center" data-id="element-664">
        <button onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))} className="rounded-full p-2 text-neutral-500 hover:bg-neutral-100 focus:outline-none" aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'} data-id="element-665">
          {isOpen ? <ChevronLeftIcon className="h-6 w-6" data-id="element-666" /> : <ChevronRightIcon className="h-6 w-6" data-id="element-667" />}
        </button>
      </div>
    </aside>;
}